import React, { useContext, useEffect, useState } from 'react';
import { SecretariasContext } from '../../../contexts/secretariasProvider';
import { ClientContext } from '../../../contexts/clientProvider';
import { UserContext } from '../../../contexts/userProvider';
import DataTable from '../../Table';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';
import Loader from '../../Loader/load';
import Visualizar from '../Visualizar';
import VincularPatrimonios from '../Consulta/vincularPatrimonios';

const Consulta = () => {
    const { secretarias, loading, setAlert, deleteSecretaria, getSecretariaByClient } = useContext(SecretariasContext);
    const { clientes } = useContext(ClientContext);
    const { isGerente } = useContext(UserContext);
    const [secretariasList, setSecretariasList] = useState(null);
    const [secretariaSelecionada, setSecretariaSelecionada] = useState(null);
    const [type, setType] = useState('');
    const [selectedClient, setSelectedClient] = useState('');

    const componentes = {
        visualizar: <Visualizar secretaria={secretariaSelecionada} closeModal={closeModal} />,
        vincularPatrimonios: <VincularPatrimonios secretaria={secretariaSelecionada} closeModal={closeModal} />,
    }

    useEffect(() => {
        if (secretarias) {
            // Só exibir lista quando há cliente selecionado
            if (selectedClient) {
                setSecretariasList(secretarias);
            } else {
                setSecretariasList(null);
            }
        }
    }, [secretarias, selectedClient]);

    const handleSelectClient = async (e) => {
        const clientId = e.target.value;
        setSelectedClient(clientId);
        
        if (clientId) {
            // Usar a função getSecretariaByClient da API
            await getSecretariaByClient(clientId);
        } else {
            // Limpar lista quando nenhum cliente está selecionado
            setSecretariasList(null);
        }
    };

    const headers = [
        {
            label: 'Nome',
            key: 'nome',
            sortable: true,
            width: 'w-2/6',
            truncate: true
        },
        {
            label: 'CNPJ',
            key: 'cnpj',
            sortable: false,
            width: 'w-1/5'
        },
        {
            label: 'Email',
            key: 'email',
            sortable: false,
            width: 'w-1/5'
        },
        {
            label: 'Cliente',
            key: 'cliente_nome',
            sortable: false,
            width: 'w-2/5'
        },
        {
            label: 'Ações',
            key: 'actions',
            sortable: false,
            width: 'w-1/5',
            actions: {
                visualizar: visualizarSecretaria,
                vincularPatrimonios: vincularPatrimoniosAction,
                ...(isGerente ? { deletar: deleteSecretariaAction } : {}),
            }
        },
    ];

    function visualizarSecretaria(id) {
        const secretaria = secretariasList.find((secretaria) => secretaria.id === id);
        setSecretariaSelecionada(secretaria);
        setType('visualizar');
    }

    function vincularPatrimoniosAction(id) {
        const secretaria = secretariasList.find((secretaria) => secretaria.id === id);
        setSecretariaSelecionada(secretaria);
        setType('vincularPatrimonios');
    }

    function deleteSecretariaAction(id) {
        if (!id) return console.error('ID não informado');
        setAlert({
            type: 'confirm',
            placeholder: 'Deseja realmente deletar a secretaria?',
            visible: true,
            confirm: true,
            title: 'Atenção!',
            callback: () => deleteSecretaria(id),
            params: id
        })
    }

    function closeModal() {
        setSecretariaSelecionada(null);
        setType('');
    }

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="secretaria-consulta-container">
                
                    <div className="mb-6">
                        <BaseSelect
                            label="Filtrar por Cliente"
                            name="cliente"
                            value={selectedClient}
                            onChange={handleSelectClient}
                            options={clientes ? clientes.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
                            placeholder="Todos os clientes"
                            valueKey="id"
                            labelKey="nome"
                            emptyOption={true}
                        />
                    </div>

                    {selectedClient && secretariasList && <DataTable data={secretariasList} headers={headers} itemsPerPage={10} />}
                    
                    {!selectedClient && (
                        <div className="flex flex-col items-center justify-center py-12 text-center">
                            <div className="text-gray-400 mb-4">
                                <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0h3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                                Selecione um cliente
                            </h3>
                            <p className="text-gray-500 dark:text-gray-400 max-w-sm">
                                Escolha um cliente no filtro acima para visualizar as secretarias associadas.
                            </p>
                        </div>
                    )}
                    {type && componentes[type]}
                </div >
            )}
        </>
    );
};

export default Consulta;
